// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"a08dda6e","28":"ae7d4156","94":"1c9ec033","124":"478bece0","246":"8c6b8fcc","444":"ecfc4d9e","458":"870557f2","506":"844ac485","541":"5890c079","605":"fd5d2b2f","684":"ca9bedff","835":"45c82c29","844":"78103e1e","858":"23983866","991":"12825c63"}[chunkId] + ".chunk.js";
};